// Theme: Zindex

const zindex = {
  base: 0,
}

export default zindex;
